export default __webpack_public_path__ + "static/BrandonGrotesque-RegularItalic-b2743c98ca40b242ffa85de6ffc9ef79.woff2";